import z from 'zod';

import type { NavigateFn } from '@tanstack/react-router';

export const WindowLabels = {
  main: 'main',
  meetingStatus: 'meeting-status',
  notifications: 'notifications',
  hummingbird: 'hummingbird',
  dictation: 'dictation',
  meetingIntent: 'meeting-intent',
  meetingAssistPopup: 'meeting-assist-popup',
} as const;

export type WindowLabel = (typeof WindowLabels)[keyof typeof WindowLabels];

export enum MainWindowCommands {
  NavigateToRoute = 'main-window-navigate-to-route',
  EnterFullScreen = 'main-window-enter-full-screen',
  LeaveFullScreen = 'main-window-leave-full-screen',
  SetBackgroundThrottling = 'set-background-throttling',
  SetTitleBarOverlayTheme = 'set-titlebar-overlay-theme',
  Minimize = 'main-window-minimize',
  Maximize = 'main-window-maximize',
  Close = 'main-window-close',
  IsMaximized = 'main-window-is-maximized',
}

type NavigateOpts = Parameters<NavigateFn>[0];

export type MainWindowNavigateEvent = {
  route: NavigateOpts['to'];
  params: NavigateOpts['params'];
  search: NavigateOpts['search'];
  hash?: string;
  newTab?: boolean;
  /** Shows the window without taking the keyboard focus from the active app */
  showInactive?: boolean;
  /** Set when a click on a push notification of this type asked for the navigation */
  notificationType?: string;
};

export const MainWindowNavigateToSchema = z.object({
  route: z.string(),
  params: z.record(z.string(), z.unknown()).optional(),
  search: z.record(z.string(), z.unknown()).optional(),
  hash: z.string().optional(),
  newTab: z.boolean().optional(),
  showInactive: z.boolean().optional(),
  notificationType: z.string().optional(),
}) as z.ZodType<MainWindowNavigateEvent>;
